<ng-container *ngIf="user$ | async; let user">
    <button (click)="startRecorder(user.canRecordUnlimited())" type="button" class="screen-record" mat-menu-item>
        <mat-icon>desktop_windows</mat-icon>
        <span i18n>Record screen</span>
    </button>
</ng-container>
